// Multi-frame playback user preferences.
//
// Backed by sessionStorage for now (was localStorage - moved for VAPT). The plan calls for these to live alongside
// the existing `userPreference` payload (GET/POST /user/preferences) — once
// the backend DTO is extended with these fields, replace these helpers with
// reads from UserContext.userSettings while keeping the same shape.

const KEY_AUTO_START = "multiFrameAutoStart";
const KEY_AUTO_HIDE = "autoHideViewportToolbar";

// VAPT: moved from localStorage to sessionStorage
const readBool = (key, defaultValue) => {
  try {
    // OLD: const raw = localStorage.getItem(key);
    const raw = sessionStorage.getItem(key);
    if (raw == null) return defaultValue;
    return raw === "true" || raw === "1";
  } catch {
    return defaultValue;
  }
};

const writeBool = (key, value) => {
  try {
    // OLD: localStorage.setItem(key, value ? "true" : "false");
    sessionStorage.setItem(key, value ? "true" : "false");
  } catch {
    /* ignore quota / privacy-mode failures */
  }
};

export const getMultiFrameAutoStart = () => readBool(KEY_AUTO_START, false);
export const setMultiFrameAutoStart = (value) => writeBool(KEY_AUTO_START, value);

export const getAutoHideViewportToolbar = () => readBool(KEY_AUTO_HIDE, false);
export const setAutoHideViewportToolbar = (value) => writeBool(KEY_AUTO_HIDE, value);
